import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const inactiveLinkStyle = { color: '#2556A6' };
  const activeLinkStyle = {
    color: '#1f4f94',
    fontWeight: '700',
    textDecoration: 'underline',
    textUnderlineOffset: '4px'
  };

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: '#ffffff' }}>
      <div className="container">
        <NavLink className="navbar-brand" to="/" onClick={closeMenu}>
          <img src="/image/final.png" width="125" height="40" className="d-inline-block align-top" alt="DOTDIP Solutions Inc. Logo" />
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          aria-label="Toggle navigation"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="desktop-nav-links">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink exact to="/" className="nav-link" activeClassName="active" style={inactiveLinkStyle} activeStyle={activeLinkStyle} onClick={closeMenu}>Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/services" className="nav-link" activeClassName="active" style={inactiveLinkStyle} activeStyle={activeLinkStyle} onClick={closeMenu}>Service</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact" className="nav-link" activeClassName="active" style={inactiveLinkStyle} activeStyle={activeLinkStyle} onClick={closeMenu}>Contact Us</NavLink>
            </li>
          </ul>
        </div>
        {isMenuOpen && (
          <div className="mobile-nav-links" id="navbarNavDropdown">
            <ul className="navbar-nav">
              <li className="nav-item">
                <NavLink exact to="/" className="nav-link" activeClassName="active" style={inactiveLinkStyle} activeStyle={activeLinkStyle} onClick={closeMenu}>Home</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/services" className="nav-link" activeClassName="active" style={inactiveLinkStyle} activeStyle={activeLinkStyle} onClick={closeMenu}>Service</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/contact" className="nav-link" activeClassName="active" style={inactiveLinkStyle} activeStyle={activeLinkStyle} onClick={closeMenu}>Contact Us</NavLink>
              </li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
}
